// extracted by mini-css-extract-plugin
export var link = "Pagination-module--link--3+rfQ";
export var wrapper = "Pagination-module--wrapper--x3fi1";